import {FilteringGridWithBulkOperations} from './filtering_grid_with_bulk_operations.js';

export const PoiLibraryView = Backbone.View.extend({
  el: '#poi-library',
  initialize: function() {
    this.editable = this.options.editable
    this.data = this.options.data
    this.poiIcons = this.options.poiIcons
    this.clubId = this.options.clubId
    this.tags = this.options.tags
    this.settings = this.options.settings || { }
    this.savedSettings = this.settings.saved || { }

    this.initTagInputBoxes()
    this.initRouteSearchBox()
    this.initGrid()

    // there is a bug somewhere in slickgrid that is forcing us to do this twice on initialization to avoid having the last columns of the last row not appear.
    this.resizeGrid();
    this.resizeGrid();

    $(window).resize(_.debounce(() => {
      this.resizeGrid();
    }, 100));
  },
  events: {
    // filtering
    'click [data-disabled]': 'showDisabledMessage',
    'keyup .filter_by_name': 'filtersChanged',
    'keyup .filter_by_description': 'filtersChanged',
    'change .filter_by_tag': 'filtersChanged',
    // bulk operations
    'click .show_bulk_op': 'showBulkOp',
    'click .batch_delete': 'batchDelete',
    'click .combine_poi': 'combine',
    'click .batch_tags': 'batchChangeTags',
    'click .batch_add_routes,.batch_remove_routes': 'onBatchRoutesClick',
    'click .associate_routes': 'associateRoutes',
    'click .poi-edit-button': 'onPoiEditClick',
    'click .new-poi-link': 'onPoiEditClick',
    'click .batch_add_tags,.batch_remove_tags': 'batchUpdateTags',
    'click .CTA.associate-routes': 'associateRoutes',
    // misc
    'click .grid_height_increase': 'increaseGridHeight',
    'click .grid_height_decrease': 'decreaseGridHeight'
  },

  initGrid: function() {
    const data = this.data
    const formatters = FilteringGridWithBulkOperations.formatters

    const formatPoiIcon = (row,cell,value,col,item) => {
      const iconData = item && _.findWhere(this.poiIcons, {'name': item.poi_type_name})
      const filename = (iconData && iconData.icon) || "generic.png"
      const icon = `/images/poi_icons/${filename}?2`
      return `<img src="${icon}" style="max-height: 100%" />`
    }

    const formatPoiEdit = (row,cell,value,col,item) => {
      return `<a href="javascript:;" class="poi-edit-button" style="color:#f80;"><span class="icon icon-edit" style="font-size:16px" data-id="${item.id}"></span></a>`
    }

    // column definitions
    const columns = [
      {id:"icon", name:'Icon', field:"icon", sortable:true, formatter: formatPoiIcon},
      {id:"name", name:'Name', field:"name", sortable:true, editor:Slick.Editors.Text},
      {id:"tag_names", name:'Tags', field:"tag_names", sortable:true, formatter: formatters.tags},
      {id:"description", name:'Description', field:"description", sortable:true, editor:Slick.Editors.Text},
      {id:"url", name:'URL', field:"url", sortable:true, editor:Slick.Editors.Text}
    ]
    if (this.editable) {
      columns.push({id:"edit", name:'', field: "edit", formatter: formatPoiEdit})
    }

    const columnWidths = Object.assign({
      icon: 10,
      edit: 10
    }, this.savedSettings.columnWidths || {})
    columns.forEach(column => column.width = columnWidths[column.id])

    const nameFilter = this.$('.filter_by_name')
    const descriptionFilter = this.$('.filter_by_description')
    const tagFilter = this.$('.filter_by_tag')
    const filterAccessors = new Map(Object.entries({
      name: nameFilter.val.bind(nameFilter),
      description: nameFilter.val.bind(descriptionFilter),
      tag_names: tagFilter.select2.bind(tagFilter, "val")
    }))

    const baseUrl = `/clubs/${this.clubId}/points_of_interest`

    this.grid = new FilteringGridWithBulkOperations(data, {
      target: '#poi_table',
      columns: columns,
      editable: this.editable,
      updatePath: (id) => `${baseUrl}/${id}.json`,
      updateParam: 'point_of_interest',
      ignoreCaseOnSort: ['name', 'location', 'url'],
      filterAccessors: filterAccessors,
      settingsOpts: this.settings.opts
    });

    this.grid.enableFiltering([
      {field: 'name', type: 'string'},
      {field: 'tag_names', type: 'arraySubset'},
      {field: 'description', type: 'string'}
    ]);

    this.grid.enableBulkOperations({
      bulkDeletePath: `${baseUrl}/batch_destroy.json`,
      idsParam: 'poi_ids'
    });

    if (this.savedSettings.sortCol) {
      this.grid.setSort(this.savedSettings.sortCol, this.savedSettings.sortAsc)
    }

    const self = this
    this.grid.slickGrid.onSelectedRowsChanged.subscribe(() => self.updateBulkOpVisibility())
    this.grid.dataView.onRowsChanged.subscribe(() => self.updateBulkOpVisibility())
    self.updateBulkOpVisibility()

  },

  /*
   * filtering
   */

  toggleFilters: function() {
    if (this.$('.toggle_filters .plus').is(':visible')) {
      this.showFilters()
    } else {
      this.hideFilters()
    }
  },

  showFilters: function() {
    this.$('.toggle_filters').find('.plus').hide().end().find('.minus').show();
    this.$('.filters').show();
  },

  hideFilters: function() {
    this.$('.toggle_filters').find('.plus').show().end().find('.minus').hide();
    this.$('.filters').hide();
  },

  filterTextInputChanged: function(e) {
    // clear on escape
    if(e.which == 27) e.currentTarget.value = '';
    this.filtersChanged()
  },

  filtersChanged: function() {
    if (this.grid) { this.grid.filterInputsChanged() }
  },

  onPoiEditClick: function(e) {
    const poiId = e.target.dataset["id"]
    rwgps.clubPoiEditor({
      poiId: poiId,
      clubId: this.clubId,
      onEditSuccess: data => this.onPoiEditSuccess(data),
      tags: this.tags
    })
  },

  onPoiEditSuccess: function(data) {
    const editedPoi = data.point_of_interest;
    // optional ids of POIs that have been combined into editedPoi
    const combinedPoiIds = data.combined_ids || [];
    const dataView = this.grid.dataView

    dataView.beginUpdate()
    if (dataView.getItemById(editedPoi.id)) {
      dataView.updateItem(editedPoi.id, editedPoi)
      combinedPoiIds.forEach(poiId => {
        if (poiId !== editedPoi.id) {
          dataView.deleteItem(poiId);
        }
      });
    } else {
      dataView.insertItem(0, editedPoi)
    }
    this.grid.setSelectedRows([])
    dataView.reSort()
    dataView.endUpdate()
  },

  /*
   * bulk operations
   */

  showBulkOp: function(e) {
    const bulkOp = $(e.currentTarget).attr('data-bulk-op');
    const show = !this.$('.bulk_op_' + bulkOp).is(':visible');
    this.$('.bulk_op').hide();
    if(show)
      this.$('.bulk_op_' + bulkOp).show();
    return false;
  },

  initTagInputBoxes: function() {
    this.$('.tag_select2_input').val('').select2({
      openOnEnter: false,
      width: '180px',
      placeholder: 'POI Tags',
      tokenSeparators: [','],
      tags: this.tags,
      selectOnBlur: true,
      formatNoMatches: () => "",
      createSearchChoice: (term) => {
        for (var value of this.tags) {
          if (value.toUpperCase() === term.toUpperCase()) {
            return {id: value, text: value};
          }
        }
        return {id: term, text: term}
      }
    });
  },

  initRouteSearchBox: function() {
    const routesButton = $('.CTA.associate-routes')
    const searchBox = $("#route_search_box")

    const updateButtonVisibility = function () {
      const routes = searchBox.select2('val')
      if (routes.length > 0) {
        routesButton.removeClass('disabled')
        routesButton.removeAttr('data-disabled')
      } else {
        routesButton.addClass('disabled')
        routesButton.attr('data-disabled', 'Use the field to search for one or more routes')
      }
    }

    searchBox.select2({
      width: 'resolve', //try style, fallback to JS to detect proper width
      //placeholder: "Select one or more routes",
      minimumInputLength: 3,
      multiple: true,
      ajax: {
        url: "/find/search.json",
        dataType: "json",
        data: function(term) {
          return {
            'search[user_id]': (rwgps.config.currentUser || {}).id,
            'search[routes]': 'true',
            'search[sort_by]': 'rank',
            'search[exclude_trips]': 'true',
            'search[keywords]': term
          }
        },
        results: function(data) {
          return {
            results: _.map(data.results, function(res) {
              return res[res.type]
            })
          }
        }
      },
      formatResult: function(res) {
        return "<span>"+(res.name || res.title)+"</span>"
      },
      formatSelection: function(res) {
        return res.name || res.title
      },
      escapeMarkup: function(m) { return m }
    })
      .on("change", updateButtonVisibility)
    updateButtonVisibility()
  },

  batchDelete: function() {
    const items = this.grid.selectedItems
    if (!items.length) {
      return // User message is set in updateBulkOpVisibility
    } else {
      const message = `Are you sure? This will delete ${items.length} selected POI${items.length > 1 ? 's' : ''}`
      customConfirm(message, () => this.grid.deleteSelectedItems())
    }
    return false
  },

  combine: function() {
    const items = this.grid.selectedItems
    if (items.length < 2) {
      return // User message is set in updateBulkOpVisibility
    } else {
      const combinePois = items.map((item) => {
        return {id: item.id, name: item.name}
      });
      rwgps.clubPoiEditor({
        poiId: combinePois[0].id,
        combinePois,
        clubId: this.clubId,
        onEditSuccess: data => this.onPoiEditSuccess(data),
        tags: this.tags
      })
    }
    return false
  },

  batchUpdateTags: function(e) {
    const tagsStr = this.$('input.tag_names').val();
    const isAdd = $(e.currentTarget).hasClass('batch_add_tags');
    const tagAction = isAdd ? 'add' : 'remove';

    if (tagsStr === '') {
      if(isAdd)
        customAlert('When adding tags, press &lt;enter&gt; after you type the tag, then click the Add Tags button.');
      else
        customAlert('When removing tags, press &lt;enter&gt; after you type the tag, then click the Remove Tags button.');
      return;
    }

    this.grid.remoteRequest({
      url: `/clubs/${this.clubId}/points_of_interest/batch_update_tags.json`,
      params: (selectedIds) => { return { poi_ids: selectedIds.join(','), tag_action: tagAction, tag_names: tagsStr } },
      done: (dataView, data) => {
        dataView.beginUpdate()
        data.points_of_interest.forEach((poiData) => {
          const poi = dataView.getItemById(poiData.id)
          poi.tag_names = poiData.tag_names
          dataView.updateItem(poi.id, poi)

          if (isAdd) {
            poi.tag_names.forEach((tag) => {
              if (!this.tags.includes(tag)) {
                this.tags.push(tag)
                this.$('select.filter_by_tag').append(`<option value="${tag}">${tag}</option>`)
              }
            })
          }
        })
        dataView.endUpdate();
        this.$('input.tag_names').select2('val', '');
      }
    })
  },

  onBatchRoutesClick: function(e) {
    const remove = $(e.currentTarget).hasClass('batch_remove_routes')
    const routesButton = $('.CTA.associate-routes')
    const searchBox = $('#route_search_box')

    routesButton.html(`${remove ? "Remove From" : "Add To"} Routes`)
    routesButton.data('remove', remove)
    searchBox.select2('val', null)
  },

  associateRoutes: function(e) {
    const routeIds = $("#route_search_box").select2('val')
    const remove = $(e.currentTarget).data('remove')

    this.grid.remoteRequest({
      url: `/clubs/${this.clubId}/batch_associate_poi.json`,
      params: (selectedIds) => {
        var result = {
          poi_ids: selectedIds.join(','),
          route_ids: routeIds.join(',')
        }
        if (remove) {
          result.remove = 1
        }
        return result
      },
      done: () => {
        $.jGrowl(`Successfully ${remove ? 'removed' : 'added'} selected POI ${remove ? 'from' : 'to'} specified routes.`)
      },
      fail: (errors) => {
        $.jGrowl(`Failed to ${remove ? 'removed' : 'added'} selected POI ${remove ? 'from' : 'to'} specified routes: ${errors.join(', ')}.`)
      }
    })
  },

  updateBulkOpVisibility: function() {
    const grid = this.grid.slickGrid
    const data = grid.getData()
    const items = grid.getSelectedRows().map(i => data.getItem(i))

    const noneSelected = items.length == 0 ? "To perform that action, please select at least one POI." : null

    const shouldDisable = {
      tags: noneSelected,
      delete: noneSelected,
      associate: noneSelected,
      combine: items.length < 2 ? "To perform that action, please select at least two POIs." : null
    }

    this.$("[data-bulk-op]").each((idx, el) => {
      const elem = $(el)
      const op = elem.data("bulk-op")
      const disableMessage = shouldDisable[op]

      if (disableMessage) {
        elem.addClass("bulk-op-disabled")
        elem.attr("data-disabled", disableMessage)
      } else {
        elem.removeClass("bulk-op-disabled")
        elem.removeAttr("data-disabled")
      }
    })

    this.$('.bulk_op').hide();
  },

  showDisabledMessage: function(e) {
    const message = $(e.currentTarget).data('disabled')
    $("#disabled-op-content").html(message)
    $("#disabled-op").modal("show")

    e.stopImmediatePropagation()
  },

  /*
   * misc
   */

  resizeGrid: function() {
    // Don't resize anything if sizes have been set by the user
    if (this.savedSettings.columnWidths) { return }

    this.grid.slickGrid.resizeCanvas();
    this.grid.slickGrid.autosizeColumns();
  },

  increaseGridHeight: function() {
    this.changeGridHeight(100);
  },
  decreaseGridHeight: function() {
    this.changeGridHeight(-100);
  },
  changeGridHeight(amount) {
    const $table = $('#poi_table');
    let height = $table.height();
    if(height + amount < 100) return;
    height += amount;
    $table.height(height).trigger('resize');
    Application.setPreference("poi_library_grid_height", height, true);
  }

});



// WEBPACK FOOTER //
// ./public/javascripts/clubs/poi_library_view.js